import React, { useState } from 'react';
import { Button, Card, message, Modal } from 'antd';
import './style/style.css';
import { useFileStore } from '../../../store/devices/fileStore';
import { File } from '../../../types/File';
import { useAuthStore } from '../../../store/auth/auth';
import { useOnlineStateStream } from '../../../store/devices/onlineStream';
import { DownloadOutlined } from '@ant-design/icons';
import { SizeType } from 'antd/es/config-provider/SizeContext';

import { useFileSelectionStore } from '../../../store/devices/useSelectedRowKeysFilesRS';
import { useOpenMoreDetails } from '../../../store/devices/useShowMoreDetails';

import IconDelete2 from '../../icons/iconDelete/IconDelete2';
import IconDwnLoad from '../../icons/iconDownload/IconDwnLoad';
import { DeleteAttachedFile } from '../../../api/file/deleteAttachedFile';
import { DownloadAttachedFile } from '../../../api/file/downloadAttachedFile';
import { AttachedFile } from '../../../types/AttachedFiles';

interface CardComponentProps {
    file: AttachedFile;
    onDeleteSuccess: () => void;
}

const CardComponentAttachedFile: React.FC<CardComponentProps> = ({ file, onDeleteSuccess }) => {
    const { setSelectedFileUID } = useFileStore();
    const { user, SmartDVRToken } = useAuthStore.getState();
    const { setIsStreamOnline } = useOnlineStateStream();
    const [previewUrlVideo, setPreviewUrlVideo] = useState<string>('');
    const [previewUrlJpg, setPreviewUrlJpg] = useState<string>('');
    const [size, setSize] = useState<SizeType>('middle');
    const { selectedFiles, setSelectedFiles } = useFileSelectionStore();
    const { openMoreDetails, setOpenMoreDetails } = useOpenMoreDetails();
    const handleDeviceClick = (FileUid: string) => {
        setSelectedFileUID(FileUid);
        setIsStreamOnline(false);
    };

    const [loadingDownload, setLoadingDownload] = useState(false);
    const [loadingDelete, setLoadingDelete] = useState(false);

    console.log(file);

    const handleDownload = async () => {
        if (!user || !SmartDVRToken) {
            message.error('Необходима авторизация');
            return;
        }

        setLoadingDownload(true);
        try {
            await DownloadAttachedFile(SmartDVRToken, user.login, file.key, file.name);
            message.success('Файл скачивается');
        } catch (error) {
            message.error('Ошибка при скачивании файла');
            console.error('Download error:', error);
        } finally {
            setLoadingDownload(false);
        }
    };

    const handleDelete = async () => {
        Modal.confirm({
            title: 'Удалить файл?',
            content: `Вы уверены, что хотите удалить файл "${file.name}"?`,
            okText: 'Удалить',
            centered: true,
            cancelText: 'Отмена',
            onOk: async () => {
                if (!user || !SmartDVRToken) {
                    message.error('Необходима авторизация');
                    return;
                }

                setLoadingDelete(true);
                try {
                    await DeleteAttachedFile(SmartDVRToken, user.login, file);
                    message.success('Файл удален');
                    onDeleteSuccess();
                } catch (error) {
                    message.error('Ошибка при удалении файла');
                    console.error('Delete error:', error);
                } finally {
                    setLoadingDelete(false);
                }
            },
        });
    };

    // const handleDelete = async () => {
    //     if (!user || !SmartDVRToken) {
    //         message.error('Необходима авторизация');
    //         return;
    //     }
    //
    //     setLoadingDelete(true);
    //     try {
    //         await DeleteAttachedFile(SmartDVRToken, user.login, file);
    //         message.success('Файл удален');
    //         // onDeleteSuccess(); // Обновляем список файлов
    //     } catch (error) {
    //         message.error('Ошибка при удалении файла');
    //         console.error('Delete error:', error);
    //     } finally {
    //         setLoadingDelete(false);
    //     }
    // };

    return (
        <div className="containerAttachedFile">
            <div className="container_cover">
                <div className="cover"></div>
                <h1 className="h1_attachedFileName">{file.name}</h1>
            </div>

            <div className="buttons">
                <IconDwnLoad style={{ cursor: 'pointer' }} onClick={handleDownload} />
                <IconDelete2
                    style={{ marginLeft: 10, cursor: 'pointer', bottom: 1, position: 'relative' }}
                    onClick={handleDelete}
                />
            </div>
        </div>
    );
};

export default CardComponentAttachedFile;
